import type {
  CollectionModel,
  FolderModel,
  HierarchyNodeModel,
} from '@/core/gql/gql-models-override.ts'

type GqlModel = { __typename?: string }

export function isFolder(node: HierarchyNodeModel): node is FolderModel {
  return (node as GqlModel).__typename === 'FolderModel'
}

export function isCollection(node: HierarchyNodeModel): node is CollectionModel {
  return (node as GqlModel).__typename === 'CollectionModel'
}

// export type HierarchyNode = 'FolderModel' | 'CollectionModel'
